import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const taiga = defineConnector({
  identifier: "taiga",
  name: "Taiga",
  tagLine: "Agile project management",
  logo,
  protocol: "http",
  tags: ["productivity", "engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://api\\.taiga\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Generate a token via the Taiga API by posting your credentials to `/api/v1/auth`, or use an application token from your Taiga settings.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Taiga host",
          placeholder: "api.taiga.io",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the auth token into the field below",
      items: [
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v1/users/me`,
  },
});
